






































































import { Vue, Component, Prop } from 'vue-property-decorator';

import ReferralExisting from '@/components/icons/ReferralExisting.vue';
import ReferralNew from '@/components/icons/ReferralNew.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import { Typography, TextField } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import CouponCoinsPreview from '@/components/molecules/CouponPreview/CouponCoinsPreview.vue';

@Component({
  components: {
    Typography,
    FilledButton,
    ReferralExisting,
    ReferralNew,
    CoinsIcon,
    TextField,
    CouponCoinsPreview
  }
})
export default class SetupCoupon extends Vue {
  @Prop(String) readonly title?: string;
  @Prop(String) readonly description?: string;
  @Prop(String) readonly labelInput?: string;
  @Prop(String) readonly placeholder?: string;
  @Prop({ default: '3' }) readonly maxlength?: string;
  @Prop(String) readonly value?: string;
  @Prop(Boolean) readonly error?: boolean;

  focus = false;

  get tPrefix() {
    return 'referralProgram.creation.step-2';
  }
}
